import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { MatSnackBar } from '@angular/material/snack-bar';
import { first } from 'rxjs/operators';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';
interface Room {
  name: string;
  value: string; // Adjust this if you need a different type, e.g., number or object
}

@Component({
  selector: 'app-property-features',
  templateUrl: './property-features.component.html',
  styleUrls: ['./property-features.component.scss'],
})
export class PropertyFeaturesComponent implements OnInit, OnChanges {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChild('inputField') inputField!: ElementRef;
  @ViewChild('panel') panels!: QueryList<MatExpansionPanel>;
  @Input() tabindex: any;
  @Input() resetPanels: boolean;
  rooms: Room[] = [];
  basicDetailsForm: FormGroup;
  parkingDetailsForm: FormGroup;
  interiorRoomDetailsForm: FormGroup;
  exteriorDetailsForm: FormGroup;
  basementDetailsForm: FormGroup;
  inputControl = new FormControl();
  isEditingBasic: boolean = false;
  isEditingParking: boolean = false;
  isEditingInterior: boolean = false;
  isEditingBasement: boolean = false;
  isEditingExterior: boolean = false;
  forms: { [key: string]: FormGroup } = {};

  displayedColumns: string[] = ['name', 'value', 'key'];
  basicDataSource: any;
  currentYear = new Date().getFullYear();
  lPropertySubTypes = [
    {
      label: 'Single Family Residence',
      key: 'single family residence',
    },
    {
      label: 'Condominium',
      key: 'condominium',
    },
    {
      label: 'Mobile Home',
      key: 'mobile home',
    },
    {
      label: 'Quadruplex',
      key: 'quadruplex',
    },
    {
      label: 'Townhouse',
      key: 'townhouse',
    },
    {
      label: 'Manufactured Home',
      key: 'manufactured home',
    },
    {
      label: 'Multi Family > 4',
      key: 'multi family > 4',
    },
    {
      label: 'MultiFamily',
      key: 'multi family',
    },
    {
      label: 'Manufactured on Land',
      key: 'manufactured on land',
    },
    {
      label: 'Apartment',
      key: 'apartment',
    },
  ];

  parkingDataSource: any;
  interiorDataSource: any;
  exteriorDataSource: any;
  BasementDataSource: any;

  basementOptions = [
    { value: 'full', viewValue: 'Full' },
    { value: 'partial', viewValue: 'Partial' },
    { value: 'crawlspace', viewValue: 'Crawl Space' },
    { value: 'walkout', viewValue: 'Walkout' },
    { value: 'daylight', viewValue: 'Daylight' },
    { value: 'finished', viewValue: 'Finished' },
    { value: 'unfinished', viewValue: 'Unfinished' },
    { value: 'semifinished', viewValue: 'Semi-finished' },
    { value: 'slab', viewValue: 'Slab' },
    { value: 'garden', viewValue: 'Garden level' },
    { value: 'lookout', viewValue: 'Lookout' },
    { value: 'cellar', viewValue: 'Cellar' },
    { value: 'bilevel', viewValue: 'Bilevel' },
    { value: 'walkup', viewValue: 'Walkup' },
    { value: 'english', viewValue: 'English' },
    { value: 'egress', viewValue: 'Egress' },
    { value: 'dugout', viewValue: 'Dugout' },
    { value: 'terrace', viewValue: 'Terrace level' },
  ];
  basementExit = [
    { value: 'Walk-out', viewValue: 'Walkout' },
    { value: 'Walk-up', viewValue: 'Walkup' },
    { value: 'Interior', viewValue: 'Inside' },
  ];

  homeTypeOptions = [
    { viewValue: 'Single Family Residence', value: 'Single Family Residence' },
    { viewValue: 'Townhouse', value: 'Townhouse' },
    { viewValue: 'Condominium', value: 'Condominium' },
    { viewValue: 'Mobile Home', value: 'Mobile Home' },
    { viewValue: 'Manufactured Home', value: 'Manufactured Home' },
    { viewValue: 'Multi Family', value: 'Multi Family' },
    { viewValue: 'Multi Family > 4', value: 'Multi Family > 4' },
    { viewValue: 'Quadruplex', value: 'Quadruplex' },
  ];
  otherFeatures = {
    heating: [
      'Active Solar',
      'Baseboard',
      'Ceiling Heat',
      'Central',
      'Coal',
      'Coal Stove',
      'Electric',
      'ENERGY STAR/ACCA RSI Qualified Installation',
      'ENERGY STAR Qualified Equipment',
      'Exhaust Fan',
      'Fireplace',
      'Fireplace Insert',
      'Floor Furnace',
      'Forced Air',
      'Geothermal',
      'Gravity',
      'Heat Pump',
      'Hot Water',
      'Humidity Control',
      'Kerosene',
      'Natural Gas',
      'Oil',
      'Passive Solar',
      'Pellet Stove',
      'Propane',
      'Radiant',
      'Radiant Ceiling',
      'Radiant Floor',
      'See Remarks',
      'Separate Meters',
      'Solar',
      'Space Heater',
      'Steam',
      'Varies by Unit',
      'Wall Furnace',
      'Wood',
      'Wood Stove',
      'Zoned',
      'Boiler',
      'Convection',
      'Ductless Mini-Split',
      'Wall Heater',
      'None',
      'Other',
    ],
    cooling: [
      'Attic Fan',
      'Ceiling Fan',
      'Central Air',
      'Dual',
      'Ductless',
      'Electric',
      'ENERGY STAR Qualified Equipment',
      'Evaporative Cooler (Swamp Cooler)',
      'Exhaust Fan',
      'Gas',
      'Geothermal',
      'Heat Pump',
      'Humidity Control',
      'Multi Units',
      'Roof Turbine',
      'Separate Meters',
      'Varies by Unit',
      'Wall/Window Unit',
      'Wall Units',
      'Whole House Fan',
      'Window Units',
      'Zoned',
      'Ductless Mini-Split',
      'None',
      'Other',
    ],
    appliances: [
      'Bar Fridge',
      'Built-In Electric Oven',
      'Built-In Electric Range',
      'Built-In Freezer',
      'Built-In Gas Oven',
      'Built-In Gas Range',
      'Built-In Range',
      'Built-In Refrigerator',
      'Convection Oven',
      'Cooktop',
      'Dishwasher',
      'Disposal',
      'Double Oven',
      'Down Draft',
      'Dryer',
      'Electric Cooktop',
      'Electric Oven',
      'Electric Range',
      'Electric Water Heater',
      'ENERGY STAR Qualified Appliances',
      'ENERGY STAR Qualified Dishwasher',
      'ENERGY STAR Qualified Dryer',
      'ENERGY STAR Qualified Freezer',
      'ENERGY STAR Qualified Refrigerator',
      'ENERGY STAR Qualified Washer',
      'ENERGY STAR Qualified Water Heater',
      'Exhaust Fan',
      'Free-Standing Electric Oven',
      'Free-Standing Electric Range',
      'Free-Standing Freezer',
      'Free-Standing Gas Oven',
      'Free-Standing Gas Range',
      'Free-Standing Range',
      'Free-Standing Refrigerator',
      'Freezer',
      'Gas Cooktop',
      'Gas Oven',
      'Gas Range',
      'Gas Water Heater',
      'Heat Pump Water Heater',
      'Humidifier',
      'Ice Maker',
      'Indoor Grill',
      'Induction Cooktop',
      'Instant Hot Water',
      'Microwave',
      'None',
      'Other',
      'Oven',
      'Plumbed For Ice Maker',
      'Portable Dishwasher',
      'Propane Cooktop',
      'Range',
      'Range Hood',
      'Refrigerator',
      'Self Cleaning Oven',
      'Smart Appliance(s)',
      'Solar Hot Water',
      'Stainless Steel Appliance(s)',
      'Tankless Water Heater',
      'Trash Compactor',
      'Vented Exhaust Fan',
      'Warming Drawer',
      'Washer',
      'Washer/Dryer',
      'Washer/Dryer Stacked',
      'Water Heater',
      'Water Purifier',
      'Water Purifier Owned',
      'Water Purifier Rented',
      'Water Softener',
      'Water Softener Owned',
      'Water Softener Rented',
      'Wine Cooler',
      'Wine Refrigerator',
    ],
    utilities: ['Cable', 'Electricity', 'Natural Gas', 'Phone', 'Sewer', 'Water', 'Propane'],
  };

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private myHomeState: MyHomeState,
    private myHomeService: MyHomeService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    let previousPmxId: string | null = null;
    this.myHomeState.activeHome$.subscribe((res: any) => {
      if (res) {
        const currentPmxId = res?.id;
        if (previousPmxId !== currentPmxId) {
          previousPmxId = currentPmxId;
          this.closeAllPanels();
        }
        this.basicDataSource = [
          { name: 'Home Type', value: res.propertySubType, key: 'propertySubType', type: 'propertySubType' }, // Example value from the database
          { name: 'Bedrooms', value: res.bedroomsTotal, key: 'bedroomsTotal', type: 'number' },
          { name: 'Full Bathrooms', value: res.bathroomsFull, key: 'bathroomsFull', type: 'number' },
          { name: 'Half Bathrooms', value: res.bathroomsHalf, key: 'bathroomsHalf', type: 'number' },
          { name: 'Number of Floors', value: res.levels, key: 'levels', type: 'number' },
          { name: 'Living Area Size (sq. ft)', value: res.livingAreaSize, key: 'livingAreaSize', type: 'number' },
          { name: 'Lot Size (sq. ft)', value: res.lotSize, key: 'lotSize', type: 'number' },
          { name: 'Year Built', value: res.yearBuilt, key: 'yearBuilt' },
        ];

        this.BasementDataSource = [
          { name: 'Basement Type', value: res.basement, key: 'basement', type: 'dropdown' },
          { name: 'Basement Exit', value: res.basementExit, key: 'basementExit', type: 'dropdown' },
          { name: 'Basement Tool Area', value: res.basementToolArea, key: 'basementToolArea' },
          { name: 'Basement Finished Area ', value: res.belowGradeFinishedArea, key: 'belowGradeFinishedArea' },
          { name: 'Basement Rooms', value: res.basementRooms, key: 'basementRooms' },
        ];

        // if (res?.roomType) this.initializeRooms(res.roomType);
        this.parkingDataSource = [
          { name: 'Parking Information', value: res.parkingFeatures, key: 'parkingFeatures' },
          { name: 'Garage Spaces', value: res.garageSpaces, key: 'garageSpaces' },
          { name: 'Carport Spaces', value: res.carportParkingSpaces, key: 'carportParkingSpaces' },
          { name: 'Driveway Spaces', value: res.drivewaySpaces, key: 'drivewaySpaces' },
        ];
        this.interiorDataSource = [
          { name: 'Appliances', value: res.appliances, key: 'appliances', type: 'multiselect' },
          { name: 'Fireplaces', value: res.fireplacesTotal, key: 'fireplacesTotal' },
          { name: 'Interior Features', value: res.interiorFeatures, key: 'interiorFeatures' },
          { name: 'Heating', value: res.heating, key: 'heating', type: 'multiselect' },
          { name: 'Cooling', value: res.cooling, key: 'cooling', type: 'multiselect' },
          { name: 'Utilities', value: res.utilities, key: 'utilities', type: 'multiselect' },
          { name: 'Green Energy Generation', value: res.greenEnergyGeneration, key: 'greenEnergyGeneration' },
        ];
        this.exteriorDataSource = [
          { name: 'Architectural Style', value: res.architecturalStyle, key: 'architecturalStyle' },
          { name: 'Pool Features', value: res.poolFeatures, key: 'poolFeatures' },
          { name: 'Patio Or Porch', value: res.patioAndPorchFeatures, key: 'patioAndPorchFeatures' },
          { name: 'Fencing', value: res.fencing, key: 'fencing' },
          { name: 'Exterior Features', value: res.exteriorFeatures, key: 'exteriorFeatures' },
        ];

        this.basicDetailsForm = this.fb.group(this.createFormGroupConfig(this.basicDataSource));
        this.parkingDetailsForm = this.fb.group(this.createFormGroupConfig(this.parkingDataSource));
        this.interiorRoomDetailsForm = this.fb.group(this.createFormGroupConfig(this.interiorDataSource));
        this.exteriorDetailsForm = this.fb.group(this.createFormGroupConfig(this.exteriorDataSource));
        this.basementDetailsForm = this.fb.group(this.createFormGroupConfig(this.BasementDataSource));
      }
    });

    this.forms = {
      interiorRoomDetailsForm: this.interiorRoomDetailsForm,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetPanels'] && changes['resetPanels'].currentValue) {
      this.closeAllPanels();
    }
  }

  closeAllPanels() {
    this.allPanelsOpen = {
      basement: false,
      exterior: false,
      basic: false,
      parking: false,
      interior: false,
    };
    if (this.panels?.length) {
      this.panels.forEach((panel) => panel.close());
    }
  }

  createFormGroupConfig(dataSource: { name: string; value: any; key: any; type: any }[]): {
    [key: string]: FormControl;
  } {
    const group: { [key: string]: FormControl } = {};

    // Initialize inclusionControls if not already defined

    dataSource.forEach((item) => {
      const defaultValue = item.value || '';
      if (item.type === 'multiselect') {
        group[item.key] = new FormControl(item.value || defaultValue || []);
      } else {
        group[item.key] = new FormControl(item.value || defaultValue || '');
      }
      switch (item.key) {
        case 'yearBuilt':
          group[item.key] = new FormControl(item.value, [
            Validators.pattern('^[0-9]*$'), // Only numbers allowed
            Validators.min(1800), // Minimum year
            Validators.max(new Date().getFullYear()), // Max year
          ]);
          break;
        default:
      }
    });

    return group;
  }

  get yearBuiltControl() {
    return this.basicDetailsForm.get('yearBuilt');
  }

  fieldConfig = {
    propertySubType: { mask: '', suffix: '' },
    parkingSpaces: { mask: 'separator.0', suffix: ' spaces' },
    lotSize: { mask: '', suffix: '' },
    yearBuilt: {
      mask: '',
      suffix: '',
    },

    bedroomsTotal: { mask: '', suffix: ' Bed' },
    upperLevelBedrooms: { mask: '', suffix: ' Bed' },
    bathroomsTotal: { mask: '', suffix: ' Bath' },
    bathroomsFull: { mask: '', suffix: ' Bath' },
    bathroomsThreeQuarter: { mask: '', suffix: ' Bath' },
    bathroomsHalf: { mask: '', suffix: ' Bath' },
    upperLevelBathrooms: { mask: '', suffix: ' Bath' },
    mainLevelBathrooms: { mask: '', suffix: ' Bath' },
    basement: this.basementOptions,
    basementExit: this.basementExit,
    homeType: this.homeTypeOptions,
    heating: {
      type: 'multiselect',
      options: this.otherFeatures.heating,
    },
    cooling: {
      type: 'multiselect',
      options: this.otherFeatures.cooling,
    },
    interiorFeatures: { type: 'input' },
    appliances: { type: 'multiselect', options: this.otherFeatures.appliances },
    utilities: { type: 'multiselect', options: this.otherFeatures.utilities },
    flooring: { type: 'input' },
    windowFeature: { type: 'input' },
    furnished: { type: 'input' },
    laundryFeatures: { type: 'input' },
  };

  initializeRooms(roomType) {
    this.rooms = [];
    const roomArray = roomType?.split(',');
    roomArray.forEach((room) => {
      this.rooms.push({ name: room.trim(), value: room.trim() });
    });
  }

  getViewValue(value: string, key: string): string {
    const options = this.fieldConfig[key];
    if (Array.isArray(options)) {
      const option = options.find((opt) => opt.value === value);
      return option ? option.viewValue : value;
    }
    return value;
  }

  onSave(section: string) {
    if (section === 'basic') {
      if (this.basicDetailsForm.invalid) return;
      this.isEditingBasic = false;
      this.updatePropertyFeature(this.basicDetailsForm.value);
    } else if (section === 'parking') {
      this.updatePropertyFeature(this.parkingDetailsForm.value);
      this.isEditingParking = false;
    } else if (section === 'interior') {
      this.updatePropertyFeature(this.interiorRoomDetailsForm.value);
      this.isEditingInterior = false;
    } else if (section === 'basement') {
      this.updatePropertyFeature(this.basementDetailsForm.value);
      this.isEditingBasement = false;
    } else if (section === 'exterior') {
      this.updatePropertyFeature(this.exteriorDetailsForm.value);
      this.isEditingExterior = false;
    }
  }

  updatePropertyFeature(value) {
    let myHomeValues = this.myHomeState.myHomeListValue.filter((myHome) => {
      return myHome.id == this.myHomeState.activeHomeValue.id;
    });
    myHomeValues = myHomeValues[0];
    myHomeValues = { ...value, ...myHomeValues };

    for (let key in value) {
      if (value.hasOwnProperty(key)) {
        myHomeValues[key] = myHomeValues[key]; // Update the value in oldJson
      }
    }
    myHomeValues = this.updateJson(myHomeValues, value);
    this.myHomeService
      .updateMyHomeValues([myHomeValues], false)
      .pipe(first())
      .subscribe((res: any) => {
        this.openSnackBar('Saved successfully', 'snackbar-success');
      });
  }

  isSelected(option: any, key: string): boolean {
    const currentItems = this.exteriorDetailsForm.get(key)?.value || [];
    return currentItems.includes(option);
  }

  onCheckboxChange(option: any, key: string) {
    const currentItems = this.exteriorDetailsForm.get(key)?.value || [];

    if (currentItems.includes(option)) {
      const index = currentItems.indexOf(option);
      if (index >= 0) {
        currentItems.splice(index, 1);
      }
    } else {
      currentItems.push(option);
    }
    this.exteriorDetailsForm.get(key)?.setValue(currentItems);
  }

  addItem(key: string, event: any) {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      const currentItems = this.exteriorDetailsForm.get(key)?.value || [];
      currentItems.push(value.trim());
      this.exteriorDetailsForm.get(key)?.setValue(currentItems); // Update the form control
    }

    if (input) {
      input.value = '';
    }
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }

  updateJson(oldJson, newJson) {
    for (let key in newJson) {
      if (newJson.hasOwnProperty(key)) {
        oldJson[key] = newJson[key];
      }
    }
    return oldJson;
  }

  toggleEditMode(section: string) {
    if (section === 'basic') {
      this.isEditingBasic = !this.isEditingBasic;
    } else if (section === 'parking') {
      this.isEditingParking = !this.isEditingParking;
    } else if (section === 'interior') {
      this.isEditingInterior = !this.isEditingInterior;
    } else if (section === 'basement') {
      this.isEditingBasement = !this.isEditingBasement;
    } else if (section === 'exterior') {
      this.isEditingExterior = !this.isEditingExterior;
    }
  }

  editingRowIndex: number;
  isEditingRow(index: number): boolean {
    return this.editingRowIndex === index;
  }

  allPanelsOpen = {};
  togglePanels(section: string, flag: boolean) {
    this.allPanelsOpen[section] = flag;
  }

  addCustomOption(formName: string, key: string, value: string) {
    const form = this.forms[formName];
    if (!form || !value.trim()) {
      return; // Ignore if form is missing or value is empty/whitespace
    }
    const currentValues = this.interiorRoomDetailsForm.get(key)?.value || [];
    if (!currentValues.includes(value)) {
      const updatedValues = [...currentValues, value];
      this.interiorRoomDetailsForm.get(key)?.setValue(updatedValues);
    } else {
      console.warn(`Value "${value}" is already included.`);
    }
  }

  removeItem(formName: string, key: string, item: string) {
    const currentValues = this.interiorRoomDetailsForm.get(key)?.value || [];
    const updatedValues = currentValues.filter((i: string) => i !== item);
    this.interiorRoomDetailsForm.get(key)?.setValue(updatedValues);
  }

  addSelectedOptions(formName: string, key: string, selectedValues: string[], inputField: HTMLInputElement) {
    const currentValues = this.interiorRoomDetailsForm.get(key)?.value || [];
    const inputValue = inputField ? inputField.value.trim() : '';
    const availableOptions = this.fieldConfig[key]?.options || [];
    let updatedValues = [...currentValues];
    if (inputValue && !updatedValues.includes(inputValue)) {
      updatedValues.push(inputValue); // Add new input value only if it's not already in the list
    }
    updatedValues = [...new Set([...updatedValues, ...selectedValues])];
    const removedValues = currentValues.filter((value) => {
      return availableOptions.includes(value) && !selectedValues.includes(value);
    });
    const finalValuesAfterRemove = updatedValues.filter((value) => !removedValues.includes(value));
    this.interiorRoomDetailsForm.get(key)?.setValue(finalValuesAfterRemove);
  }
}
